export interface CommunityVoteAllowance {
	limit: number;
	remaining: number;
	resetAt: string;
}

type CommunityVoteAllowanceScope = Pick<Document, 'querySelectorAll'>;

export function paintCommunityVoteAllowance(
	scope: CommunityVoteAllowanceScope,
	input: { isLoggedIn: boolean; allowance?: CommunityVoteAllowance },
): void {
	const allowance = input.allowance;
	const visitor = !input.isLoggedIn || !allowance;
	const limit = Math.max(0, allowance?.limit ?? 3);
	const remaining = Math.min(limit, Math.max(0, allowance?.remaining ?? limit));
	const used = limit - remaining;
	const label = visitor ? 'Sign in to use up to 3 daily votes' : `You used ${used} of ${limit} votes today. Resets ${formatReset(allowance.resetAt)}.`;
	const title = visitor
		? 'Sign in to use up to 3 daily votes'
		: label;

	scope.querySelectorAll<HTMLElement>('[data-community-vote-allowance]').forEach((badge) => {
		badge.dataset.communityVoteAllowance = String(used);
		badge.dataset.communityVoteAllowanceMode = visitor ? 'visitor' : 'member';
		badge.setAttribute('aria-label', label);
		badge.title = title;
		const value = badge.querySelector<HTMLElement>('[data-community-vote-allowance-used]');
		const total = badge.querySelector<HTMLElement>('[data-community-vote-allowance-limit]');
		const suffix = badge.querySelector<HTMLElement>('[data-community-vote-allowance-label]');
		if (value) value.textContent = visitor ? '—' : String(used);
		if (total) total.textContent = String(visitor ? 3 : limit);
		if (suffix) suffix.textContent = visitor ? 'daily votes' : 'used today';
	});

	scope.querySelectorAll<HTMLButtonElement>('.vote-btn, .idea-detail-vote-btn').forEach((button) => {
		const item = button.closest<HTMLElement>('[data-status][data-idea-id]');
		const voting = item?.dataset.status === 'voting' && item.dataset.isAdopted !== 'true';
		if (!voting) return;
		// A zero allowance cannot distinguish a new fourth support from a
		// same-day reactivation after cancellation. Keep this control enabled;
		// the atomic server state machine authoritatively accepts or rejects it.
		if (button.dataset.communityVoteCooldown === 'true') return;
		button.disabled = false;
		button.removeAttribute('aria-disabled');
	});
}

function formatReset(resetAt: string): string {
	const parsed = new Date(resetAt);
	return Number.isFinite(parsed.getTime()) ? parsed.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', timeZone: 'UTC' }) + ' UTC' : 'at midnight UTC';
}
